import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { UserProvider } from './providers/UserProvider';
import { ImportedPlayersProvider } from './providers/ImportedPlayersProvider';
import { HomebrewProvider } from './providers/HomebrewProvider';
import { ImagesProvider } from './providers/ImagesProvider';

ReactDOM.render(
    <UserProvider> 
        <ImportedPlayersProvider> 
            <HomebrewProvider> 
                <ImagesProvider> 
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ImagesProvider> 
            </HomebrewProvider> 
        </ImportedPlayersProvider> 
    </UserProvider>,
    document.getElementById('root')
);